// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './store.js';
import './plugins/base';
import './plugins/chartist';
import './plugins/vee-validate';
import './plugins/vue-world-map';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import axios from 'axios';
import firebase from '@/Firebase.js';
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import HighchartsVue from 'highcharts-vue';
import Tawk from './plugins/hexa-tawk';
import { firestorePlugin } from 'vuefire';
import dayjs from 'dayjs';
import VueTheMask from 'vue-the-mask';
import '@/filters.js';
import Pusher from 'pusher-js';
import VuetifyMoney from "vuetify-money";

Vue.use(VuetifyMoney);

dayjs.locale('es');

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.prototype.$pusher = new Pusher('d72799ec9e717da8968f', { cluster: 'us2' });

Vue.use(VueTheMask);

Vue.use(VueIziToast);

Vue.use(HighchartsVue);

Vue.use(firestorePlugin);

Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/596e24c56edc1c10b03468d1/default'
});

let app;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  }
});
